import { ContentCard } from "@msuite/ui/content-card";
import type { IconType } from "@msuite/ui/icons";
import { DataTable } from "@msuite/ui/table";
import type { ClassNameProps } from "@msuite/ui/types";
import type { IncomingInvoiceDashboardList } from "@msuite/utils/types";
import { columns } from "./table-config";

/** Props Interface */
interface IncomingInvoicesListTileProps extends ClassNameProps {
	title: string;
	icon: IconType;
	invoices: IncomingInvoiceDashboardList;
	isLoading: boolean;
	persistenceKey: `${string}-table`;
}

export function IncomingInvoicesListTile({
	title,
	icon,
	invoices,
	persistenceKey,
	className,
	isLoading,
}: IncomingInvoicesListTileProps) {
	/** Render */
	return (
		<ContentCard
			title={title}
			icon={icon}
			isCollapsible={false}
			className={className}
			contentClassName="h-96"
			variant="plain"
		>
			<DataTable
				data={invoices}
				columns={columns}
				persistenceKey={persistenceKey}
				isLoading={isLoading}
				queryKey={undefined}
				refetch={undefined}
				menu={null}
			/>
		</ContentCard>
	);
}
